import { getTransportes, createTransporte, updateTransporte, deleteTransporte } from '../models/transporteModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase.js';
import { toasts } from "svelte-toasts";

// Fetch a list of transportes with pagination
export async function fetchTransporte(page, perPage) {
  try {
    const response = await getTransportes(page, perPage);
    return {
      transporte: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching transportes:", error);
    Swal.fire('Error', 'No se pudieron cargar los transportes', 'error');
    return null;
  }
}

// Save or update a transporte
export async function saveTransporte(transporte, currentTransporteId) {
  try {
    if (currentTransporteId) {
      await updateTransporte(currentTransporteId, transporte);
      toasts.add({
        title: 'Éxito',
        description: 'Transporte guardado exitosamente',
        duration: 3000, // 3 seconds
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createTransporte(transporte);
      toasts.add({
        title: 'Éxito',
        description: 'Transporte creado exitosamente',
        duration: 3000, // 3 seconds
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving transporte:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el transporte',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Delete a transporte by ID
export async function removeTransporte(id) {
  try {
    await deleteTransporte(id);
    toasts.add({
      title: 'Éxito',
      description: 'Transporte eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting transporte:", error);
    Swal.fire('Error', 'No se pudo eliminar el transporte', 'error');
  }
}

// Real-time subscription to changes in the 'transporte' collection
export function subscribeToTransportes(searchQuery, handleSearch) {
  pb.collection('transporte').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Refresh the list with the first page
  });
}

// Unsubscribe from real-time events
export function unsubscribeFromTransportes() {
  pb.collection('transporte').unsubscribe('*');
}

// Search transportes by query
export async function searchTransportes(query, page = 1, perPage = 10) {
  const response = await pb.collection('transporte').getList(page, perPage, {
    filter: `descrip ~ "${query}"`, 
    $autoCancel: false,
  });
  return {
    transporte: response.items,
    totalRecords: response.totalItems,
    currentPage: response.page,
  };
}